import { useFormContext } from 'react-hook-form';
import { CompoundField, Grid } from '@optimus-web/core';
import { FormInputField, FormPercentageInputField, lt } from '@mews/framework';
import { SettlementValueType } from '@mews-commander/data-access';
import { EnumSelectField } from '@mews-commander/form';
import { SettlementRuleFormField } from '../types';
import { CurrencySelectField } from '../../../components/form/hookFields';
import { FormValues } from './schema';

export const SettlementRuleValueField = ({
    disableValueDiscriminator = false,
    defaultCurrencyCode,
}: {
    disableValueDiscriminator?: boolean;
    defaultCurrencyCode: string;
}) => {
    const { watch, setValue, clearErrors } = useFormContext<FormValues>();

    const value = watch(SettlementRuleFormField.Value);

    const handleOnChange = () => {
        if (value.discriminator === SettlementValueType.Percentage) {
            setValue(SettlementRuleFormField.Value, {
                discriminator: SettlementValueType.Percentage,
                value: { value: 1 },
            });
        } else {
            setValue(SettlementRuleFormField.Value, {
                discriminator: SettlementValueType.Flat,
                value: { value: 0, currencyCode: defaultCurrencyCode },
            });
        }

        clearErrors(`${SettlementRuleFormField.Value}.value.value`);
    };

    const isPercentageValue = value.discriminator === SettlementValueType.Percentage;

    return (
        <CompoundField
            name={SettlementRuleFormField.Value}
            label={lt('Amount')}
            helper={lt('SettlementRuleAmountHelperText')}
            required
        >
            <Grid
                templateColumns={isPercentageValue ? '1fr 1fr' : '2fr 3fr 1fr'}
                largePhoneMax={{ templateColumns: '1fr' }}
                gap="100"
            >
                <EnumSelectField
                    name={`${SettlementRuleFormField.Value}.discriminator`}
                    required
                    enumClass={SettlementValueType}
                    enumPrefix="SettlementValueType"
                    onChange={handleOnChange}
                    omitHint
                    disabled={disableValueDiscriminator}
                />
                {isPercentageValue ? (
                    <FormPercentageInputField
                        name={`${SettlementRuleFormField.Value}.value.value`}
                        required
                        insideCompoundField
                    />
                ) : (
                    <>
                        <FormInputField
                            name={`${SettlementRuleFormField.Value}.value.value`}
                            required
                            type="number"
                            insideCompoundField
                        />
                        <CurrencySelectField
                            required
                            currencyScope="currentEnterprise"
                            name={`${SettlementRuleFormField.Value}.value.currencyCode`}
                        />
                    </>
                )}
            </Grid>
        </CompoundField>
    );
};
